import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyContext } from '../../utils/currencyContext';
import getCurrencySign from '../../utils/getCurrencySign';
import { domainPrices } from '../../resources/static';
import searchIcon from '../../assets/img/search-icon.svg';
import './domainMainForm.scss';

function DomainMainForm() {
    const { i18n, t } = useTranslation();
    const [domain, setDomain] = useState('');
    const currentLanguage = i18n.language;
    const { currentCurrency } = useContext(CurrencyContext);
    const isFR = currentLanguage === 'fr';
    const sign = getCurrencySign(currentCurrency);
    const domainData = domainPrices[currentCurrency];

    const getCurrencyCode = (currency) => {
        let currencyCode = 1;

        if (currency === 'usd') {
            currencyCode = 4;
        } else if (currency === 'gbp') {
            currencyCode = 5;
        }

        return currencyCode;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // Construct the action URL with the search query
        const actionURL = `https://obambu.com/order/?domain=register&sld=${encodeURIComponent(domain.split('.')[0])}&tld=.${encodeURIComponent(domain.split('.')[1])}&currency=${getCurrencyCode(currentCurrency)}&language=${isFR ? 'french' : 'english'}`;

        // Redirect to the action URL
        window.location.href = actionURL;
    };

    return (
        <form className="domain-main-search" onSubmit={handleSubmit}>
            <div className="domain-checkup-left">
                <input
                    type="text"
                    className="domain-input"
                    name="domain"
                    placeholder={t('home-page.search-placeholder')}
                    pattern="^[a-zA-Z0-9.àéèç-]+$"
                    title={t('domain-page.search-title')}
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                />
            </div>
            <div className="domain-checkup-right">
                <button type="submit">
                    <img src={searchIcon} alt="Search icon" />
                    {t('buttons.search')}
                </button>
            </div>
            <div className="domain-tld-prices">
                <ul>
                    <li>
                        <span className="domain-tld-style">.com</span>
                        <span className="price">
                            {domainData.com}
                            <span className="currency">{sign}</span>
                        </span>
                    </li>
                    <li>
                        <span className="domain-tld-style">.net</span>
                        <span className="price">
                            {domainData.net}
                            <span className="currency">{sign}</span>
                        </span>
                    </li>
                    <li>
                        <span className="domain-tld-style">.fr</span>
                        <span className="price">
                            {domainData.fr}
                            <span className="currency">{sign}</span>
                        </span>
                    </li>
                    <li>
                        <span className="domain-tld-style">.be</span>
                        <span className="price">
                            {domainData.be}
                            <span className="currency">{sign}</span>
                        </span>
                    </li>
                    <li>
                        <span className="domain-tld-style">.eu</span>
                        <span className="price">
                            {domainData.eu}
                            <span className="currency">{sign}</span>
                        </span>
                    </li>
                    <li>
                        <span className="domain-tld-style">.org</span>
                        <span className="price">
                            {domainData.org}
                            <span className="currency">{sign}</span>
                        </span>
                    </li>
                </ul>
            </div>
        </form>
    );
}

export default DomainMainForm;
